import { Container } from '@mui/material';
import Page from 'src/components/page/page';
import ProductForm from './components/product-form';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import RegisterCodes from './components/code-modal';
import RedeemsModal from './components/redeem-modal';
import RegisterCpfs from './components/cpf-modal';
import { useLPProductDetails } from './product-lp-details.hook';

export default function LPProductDetails() {
  const hook = useLPProductDetails();

  return (
    <Page title="Detalhes do Produto">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading={hook.title} links={[]} action={[]} />
        <ProductForm hook={hook} />
        <RegisterCodes productDetailsHook={hook} />
        <RegisterCpfs productDetailsHook={hook} />
        <RedeemsModal productHook={hook} />
      </Container>
    </Page>
  );
}
